export const actionConst = {
    OPEN_SERVICE_MODAL: 'OPEN_SERVICE_MODAL',
    CLOSE_SERVICE_MODAL: 'CLOSE_SERVICE_MODAL',
    SHOW_SERVICE_OK: 'SHOW_SERVICE_OK',
    HIDE_SERVICE_OK: 'HIDE_SERVICE_OK',
};
